// extracted by mini-css-extract-plugin
export var actionButton = "_6v-1";
export var actionButtons = "_6v-2";
export var actions = "_6v-0";
export var aiUnread = "_6v-10";
export var alignCenter = "_6v-h";
export var backWrapper = "_6v-3";
export var cellContainer = "_6v-4";
export var checkboxContainer = "_6v-5";
export var contentContainer = "_6v-6";
export var contentHeader = "_6v-8";
export var conversationsTableWrapper = "_6v-s";
export var draftReplyBadgeContainer = "_6v-m";
export var dropdownItem = "_6v-b";
export var dropdownItemsContainer = "_6v-a";
export var dropdownTitle = "_6v-c";
export var errorIcon = "_6v-7";
export var filter = "_6v-d";
export var gray = "_6v-i";
export var headerActionButtons = "_6v-e";
export var headerCheckboxContainer = "_6v-f";
export var icon = "_6v-j";
export var menuContainer = "_6v-k";
export var noMoreTicketsIcon = "_6v-12";
export var noMoreTicketsSubText = "_6v-13";
export var oneLine = "_6v-l";
export var optionsButton = "_6v-n";
export var plus = "_6v-o";
export var portalButtonsWrapper = "_6v-g";
export var red = "_6v-p";
export var scrolledTop = "_6v-9";
export var search = "_6v-q";
export var selectedConversationsCount = "_6v-r";
export var spinner = "_6v-t";
export var strong = "_6v-u";
export var summaryCell = "_6v-v";
export var tableContainer = "_6v-11";
export var tagContainer = "_6v-w";
export var threeDots = "_6v-x";
export var twoLines = "_6v-y";
export var unread = "_6v-z";